import Swal from "sweetalert2";
import { useStore } from "../store";
import { DeleteButton } from "./DeleteButton";
import { CreateButton } from "./CreateButton";
import { ViewButton } from "./ViewButton";
import { deleteInfo, fetchAnimes, fetchBroadcasts, updateInfo } from "../info";

const style = {
  display: "flex",
  marginLeft: "auto",
  marginRight: 12,
  gap: 6,
  alignItems: "center"
};

export function HeaderButtons(props) {
  const { token, setToken, anime, setAnime, broadcast, setBroadcast, broadcasts } = useStore();

  async function onAnimeSave() {
    const animes = await fetchAnimes();
    if (anime) setAnime(animes.find(a => a.id === anime.id));
  }

  async function onBroadcastSave() {
    const broadcasts = await fetchBroadcasts(anime.id);
    if (broadcast) setBroadcast(broadcasts.find(b => b.id === broadcast.id));
  }

  function onAnimeCreate(e) {
    const defaultDate = new Date(Date.now() + parseInt(process.env.REACT_APP_TIMEZONE_OFFSET));
    defaultDate.setUTCMinutes(0, 0, 0);

    Swal.fire({
      title: "애니메이션 추가",
      html: [
        "<span>이름, 방송사, 출시일, 방송 길이(분)을 입력해주세요.</span>",
        "<input id='swal2-name' type='text' class='swal2-input' placeholder='애니메이션 이름'>",
        "<input id='swal2-broadcaster' type='text' class='swal2-input' placeholder='방송사'>",
        `<input id="swal2-release-time" type="datetime-local" class="swal2-input" value="${defaultDate.toISOString().slice(0, -1)}">`,
        "<input id='swal2-duration' type='number' class='swal2-input' value='30'>"
      ].join(""),
      showCancelButton: true,
      confirmButtonText: "추가",
      cancelButtonText: "취소",
      icon: "info",
      preConfirm: () => new Promise((resolve) => resolve({
        name: document.getElementById("swal2-name").value,
        broadcaster: document.getElementById("swal2-broadcaster").value,
        releaseTime: Date.parse(document.getElementById("swal2-release-time").value + "Z") - parseInt(process.env.REACT_APP_TIMEZONE_OFFSET),
        duration: parseInt(document.getElementById("swal2-duration").value)
      }))
    }).then(async result => {
      if (result.isConfirmed) {
        const { name, broadcaster, releaseTime, duration } = result.value;

        updateInfo("/anime", {
          name,
          broadcaster,
          releaseTime,
          broadcastDuration: duration * 1000*60
        }, "애니메이션", onAnimeSave, "POST");
      }
    });
  }

  function onAnimeDelete(e) {
    if (!anime) return;

    Swal.fire({
      title: "애니메이션 표시 관리",
      html: `아래 버튼을 눌러 애니메이션을 숨기거나 삭제할 수 있습니다.<br/>애니메이션은 삭제한 후 복원할 수 없습니다!`,
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "숨김",
      denyButtonText: "삭제",
      cancelButtonText: "취소",
      icon: "info"
    }).then(async result => {
      if (result.isConfirmed) {
        updateInfo(`/anime/${anime.id}/hide`, { value: true }, "애니메이션 숨김", onAnimeSave);
      } else if (result.isDenied) {
        deleteInfo(`/anime/${anime.id}`, "애니메이션", onAnimeSave);
      }
    });
  }

  function onBroadcastCreate(e) {
    if (!anime) return;

    const episodeNumbers = broadcasts.map(b => parseInt(b.episode.replace("화", "").replace("-", "").replace(/ /g, ""))).filter(episode => !isNaN(episode));
    const maxEpisodeNumber = Math.max(...episodeNumbers, 0);

    const lastBroadcast = broadcasts.find(b => parseInt(b.episode.replace("화", "").replace("-", "").replace(/ /g, "")) === maxEpisodeNumber);
    let defaultDate = null;
    if (lastBroadcast) {
      const animeReleaseDate = new Date(anime.releaseTime + parseInt(process.env.REACT_APP_TIMEZONE_OFFSET));
      defaultDate = new Date(lastBroadcast.broadcastStartTime + parseInt(process.env.REACT_APP_TIMEZONE_OFFSET) + 1000*60*60*24*7); // add 1 week
      defaultDate.setUTCHours(animeReleaseDate.getUTCHours());
      defaultDate.setUTCMinutes(animeReleaseDate.getUTCMinutes());
      defaultDate.setUTCSeconds(animeReleaseDate.getUTCSeconds());
      defaultDate.setUTCMilliseconds(animeReleaseDate.getUTCMilliseconds());
    } else {
      defaultDate = new Date(anime.releaseTime + parseInt(process.env.REACT_APP_TIMEZONE_OFFSET));
    }

    Swal.fire({
      title: "방송 추가",
      html: [
        "<span>시작일, 추가 개수, 에피소드명 템플릿을 입력해주세요.</span>",
        `<input id="swal2-start-time" type="datetime-local" class="swal2-input" value="${defaultDate.toISOString().slice(0, -1)}">`,
        "<input id='swal2-count' type='number' class='swal2-input' value='1'>",
        `<input id="swal2-episode" type="text" class="swal2-input" value="%n${maxEpisodeNumber === 0 ? "" : `+${maxEpisodeNumber}`}%화">`
      ].join(""),
      showCancelButton: true,
      confirmButtonText: "추가",
      cancelButtonText: "취소",
      icon: "info",
      preConfirm: () => new Promise((resolve) => resolve({
        startTime: Date.parse(document.getElementById("swal2-start-time").value + "Z") - parseInt(process.env.REACT_APP_TIMEZONE_OFFSET),
        count: parseInt(document.getElementById("swal2-count").value),
        episode: document.getElementById("swal2-episode").value
      }))
    }).then(async result => {
      if (result.isConfirmed) {
        const { startTime, count, episode } = result.value;
        const logs = [];
        for (let i = 0; i < count; i++) {
          // chatgpt go brrrr
          const episodeName = episode.replace(/%n(\+(\d+))?%/g, (_, __, offset) => i + 1 + (offset ? parseInt(offset) : 0));
          const timeOffset = 1000*60*60*24*7 * i;
          const createBroadcastRequest = await fetch(`${process.env.REACT_APP_API}/anime/${anime.id}/broadcast`, {
            headers: {
              "authorization": token,
              "content-type": "application/json"
            },
            method: "POST",
            body: JSON.stringify({
              broadcastStartTime: startTime + timeOffset,
              broadcastFinishTime: startTime + anime.broadcastDuration + timeOffset,
              episode: episodeName
            })
          }).then(async res => {
            if (res.status === 201) logs.push(true);
            else if (res.status === 401) {
              setToken(null);
              Swal.fire({
                title: "방송 추가 실패",
                html: "로그인 정보가 올바르지 않습니다.<br/>다시 로그인해주세요.",
                icon: "error",
                confirmButtonText: "확인"
              });
              return false;
            } else {
              const body = await res.text();
              console.error(body);
              logs.push(body);
            }
          }).catch(err => {
            logs.push(false);
            console.error(err);
          });
          if (createBroadcastRequest === false) return;
        }

        if (logs.some(log => log !== true)) {
          const failedLogs = logs.filter(log => log !== true);
          Swal.fire({
            title: "방송 추가 실패",
            html: `방송 ${count}개 중 ${failedLogs.length}개 추가에 실패하였습니다.<br/><br/>${failedLogs.join("<br/>")}`
          });
        } else {
          onBroadcastSave();
        }
      }
    });
  }

  function onBroadcastDelete(e) {
    if (!broadcast) return;

    Swal.fire({
      title: "방송 표시 관리",
      html: [
        "아래 버튼을 눌러 방송을 숨기거나 삭제할 수 있습니다.",
        "방송은 삭제한 후 복원할 수 없습니다!"
      ].join("<br/>"),
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "숨김",
      denyButtonText: "삭제",
      cancelButtonText: "취소",
      icon: "info"
    }).then(async result => {
      if (result.isConfirmed) {
        fetch(`${process.env.REACT_APP_API}/broadcast/${broadcast.id}/hide`, {
          headers: {
            "content-type": "application/json"
          },
          method: "PATCH",
          body: JSON.stringify({ value: true })
        }).then(async res => {
          if (res.status === 204) onBroadcastSave();
          else Swal.fire("방송 숨김 실패", await res.text(), "warning");
        }).catch(err => {
          console.error(err);
          Swal.fire("방송 숨김 실패", err, "error");
        });
      } else if (result.isDenied) {
        fetch(`${process.env.REACT_APP_API}/broadcast/${broadcast.id}`, {
          method: "DELETE"
        }).then(async res => {
          if (res.status === 204) onBroadcastSave();
          else Swal.fire("방송 삭제 실패", await res.text(), "warning");
        }).catch(err => {
          console.error(err);
          Swal.fire("방송 삭제 실패", err, "error");
        });
      }
    });
  }

  return (<>
    <div style={ style }>
      <ViewButton type={ props.type }/>
      <DeleteButton onClick={ props.type === "anime" ? onAnimeDelete : onBroadcastDelete }/>
      <CreateButton onClick={ props.type === "anime" ? onAnimeCreate : onBroadcastCreate }/>
    </div>
  </>);
}
